import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { ApiError } from '../api/client'
import { useResendVerification, useVerifyEmail } from './useOnboarding'

// Wiederverwendbare 6-stellige Code-Eingabe für die PFLICHT-E-Mail-Verifizierung (Registrierung & Login-Resume).
// Bei Erfolg ist man eingeloggt → onVerified() (i. d. R. Navigation in die App).
export function EmailVerifyForm({ login, email, onVerified }: { login: string; email: string | null; onVerified: () => void }) {
  const verify = useVerifyEmail()
  const resend = useResendVerification()
  const [code, setCode] = useState('')

  function onSubmit(e: FormEvent) {
    e.preventDefault()
    verify.mutate({ login, code: code.trim() }, { onSuccess: onVerified })
  }

  const errorMessage = verify.error instanceof ApiError ? verify.error.message : verify.isError ? 'Bestätigung fehlgeschlagen' : null

  return (
    <div className="centered">
      <form className="card login" onSubmit={onSubmit}>
        <h1>E-Mail bestätigen</h1>
        <p className="hint">
          Wir haben dir einen 6-stelligen Code{email ? ` an ${email}` : ''} geschickt (15 Minuten gültig). Bitte hier eingeben.
        </p>
        <label className="field">
          <span>Bestätigungscode</span>
          <input
            name="code"
            inputMode="numeric"
            autoComplete="one-time-code"
            autoCorrect="off"
            spellCheck={false}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          />
        </label>
        {errorMessage && (
          <p className="error" role="alert">
            {errorMessage}
          </p>
        )}
        <button type="submit" className="btn" disabled={verify.isPending || code.length !== 6}>
          {verify.isPending ? 'Prüfe…' : 'Bestätigen'}
        </button>
        <button type="button" className="wf-linkbtn" onClick={() => resend.mutate({ login })} disabled={resend.isPending}>
          {resend.isPending ? 'Sende…' : resend.isSuccess ? 'Neuer Code gesendet ✓' : 'Code erneut senden'}
        </button>
        <nav className="wf-legalfoot" aria-label="Navigation">
          <Link to="/login">Zurück zur Anmeldung</Link>
        </nav>
      </form>
    </div>
  )
}
